/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_5_BodyInputs */

const da_forside_safe_5_body = /** @type {(inputs: Forside_Safe_5_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appen driftes i EU, og der bruges kun AI-udbydere i EU.`)
};

/** @type {(inputs: Forside_Safe_5_BodyInputs) => LocalizedString} */
const en_forside_safe_5_body = da_forside_safe_5_body;

/**

* @param {Forside_Safe_5_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_5_body = /** @type {((inputs?: Forside_Safe_5_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_5_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_5_body(inputs)
	return /** @type {LocalizedString} */ ("Appen driftes i EU, og der bruges kun AI-udbydere i EU.")
});